export default "__VITE_ASSET__b62b426b__"